export default __webpack_public_path__ + "static/helping-break-down-barriers-mobile-73df71a5495c3542ec30722057d861c8.jpg";